var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * createForm
 * @author georgemo
 */
import React from 'react';
import createField from './createField';
import { createUseFormData } from './useFormData';
import createContainer from './createContainer';
import { scrollDomController } from './scrollDomController';
export default function createFormFactory(FieldWrapperComponent) {
    return function formFactory(initialValues, options) {
        var _a = scrollDomController(), addItem = _a.addItem, scrollErrors = _a.scrollErrors;
        var _b = createContainer(createUseFormData(initialValues, scrollErrors)), Form = _b.Provider, useContainer = _b.useContainer, Consumer = _b.Consumer;
        var OriginField = createField(useContainer, FieldWrapperComponent, options);
        function Field(props) {
            return React.createElement(OriginField, __assign({}, props, { addItem: addItem }));
        }
        function withForm(Component) {
            return React.forwardRef(function (props, ref) {
                return (React.createElement(Form, null,
                    React.createElement(Component, __assign({}, props, { ref: ref }))));
            });
        }
        function withFormData(Component) {
            return React.forwardRef(function (props, ref) {
                return (React.createElement(Consumer, null, function (formData) {
                    return React.createElement(Component, __assign({}, props, { formData: formData, ref: ref }));
                }));
            });
        }
        function useValues() {
            var _a = useContainer(), values = _a.values, setValues = _a.setValues, resetValues = _a.resetValues, removeValue = _a.removeValue, removeValues = _a.removeValues, setInitialValues = _a.setInitialValues, initialValues = _a.initialValues, getDirtyState = _a.getDirtyState;
            return { values: values, setValues: setValues, resetValues: resetValues, removeValue: removeValue, removeValues: removeValues, setInitialValues: setInitialValues, initialValues: initialValues, getDirtyState: getDirtyState };
        }
        function useValidate() {
            var _a = useContainer(), setRules = _a.setRules, getRule = _a.getRule, getRules = _a.getRules, removeRule = _a.removeRule, removeRules = _a.removeRules, validate = _a.validate, validateAndScroll = _a.validateAndScroll, validateWithOption = _a.validateWithOption;
            return { setRules: setRules, getRule: getRule, getRules: getRules, removeRule: removeRule, removeRules: removeRules, validate: validate, validateAndScroll: validateAndScroll, validateWithOption: validateWithOption };
        }
        function useErrors() {
            var _a = useContainer(), errors = _a.errors, setError = _a.setError, removeError = _a.removeError, removeErrors = _a.removeErrors, resetErrors = _a.resetErrors;
            return { errors: errors, setError: setError, removeError: removeError, removeErrors: removeErrors, resetErrors: resetErrors };
        }
        function useTouchedState() {
            var _a = useContainer(), touchedState = _a.touchedState, setTouchedState = _a.setTouchedState;
            return { touchedState: touchedState, setTouchedState: setTouchedState };
        }
        return {
            Form: Form,
            Field: Field,
            withForm: withForm,
            withFormData: withFormData,
            useValues: useValues,
            useErrors: useErrors,
            useValidate: useValidate,
            useTouchedState: useTouchedState,
        };
    };
}
